export const CONTENT_FILTER_SETTINGS_SLICE_NAME = 'contentFilterSettings';
export const CONTENT_FILTER_DEFAULT_TYPE = 'azure';
